import { merge } from "lodash";
import addressModuleMutations from "./addressModule/mutations";
import shipmentModuleMutations from "./shipmentModule/mutations";

export default merge(addressModuleMutations, shipmentModuleMutations);
